// @ts-nocheck

import { fabric } from 'fabric';
import 'fabric-history';

/**
 * 손가락 스크롤, 줌인/아웃 허용
 */
(fabric.Canvas.prototype as any).__onTouchStart = (
  fabric.Canvas.prototype as any
)._onTouchStart;

(fabric.Canvas.prototype as any)._onTouchStart = function (
  e: TouchEvent
): void {
  if (
    e.type === 'touchstart' &&
    (e.touches[0].touchType === 'direct' ||
      e.touches[0].radiusX > 0 ||
      e.touches.length > 1)
  ) {
    // 손가락이면 Fabric 이 touchstart 에서 preventDefault 를 하지 않아
    // 이어지는 호환용 mousedown 으로 점 찍기 필기가 생길 수 있음 → 플래그로 차단
    if (this.isDrawingMode) {
      this._fingerSyntheticDrawingBlocked = true;
      if (this._fingerSyntheticDrawingClearTimer) {
        clearTimeout(this._fingerSyntheticDrawingClearTimer);
      }
      this._fingerSyntheticDrawingClearTimer = setTimeout(() => {
        this._fingerSyntheticDrawingBlocked = false;
        this._fingerSyntheticDrawingClearTimer = 0;
      }, 600);
    }
    return;
  }

  if (this._fingerSyntheticDrawingClearTimer) {
    clearTimeout(this._fingerSyntheticDrawingClearTimer);
    this._fingerSyntheticDrawingClearTimer = 0;
  }
  this._fingerSyntheticDrawingBlocked = false;
  this.__onTouchStart(e);
};

/**
 * Safari 브라우저에서 "Canvas memory use exceeds the maximum limit" warning 발생하는 문제 수정
 */
fabric.Object.prototype.objectCaching = false;

/**
 * 기본 객체는 컨트롤 숨김 (텍스트 객체는 개별적으로 활성화)
 */
fabric.Object.prototype.hasControls = false;

/**
 * 텍스트 객체의 변형 컨트롤 터치 최적화
 */
// 터치 코너 크기를 더 크게 설정
fabric.Object.prototype.touchCornerSize = 30;
fabric.Object.prototype.cornerSize = 10;

// 회전 핸들 크기 조정
fabric.Object.prototype.rotatingPointOffset = 40;

/**
 * 손가락으로 그리기 막기
 *
 * - 터치: radiusX > 0 이면 손가락으로 간주
 * - 손가락 touchstart 조기 반환 후 호환용 mousedown: sourceCapabilities 가 없는
 *   기기도 있어 _fingerSyntheticDrawingBlocked 로 차단 (_onTouchStart 에서 설정)
 */
(fabric.Canvas.prototype as any)._shouldAllowDrawingModeEvent = function (
  e: Event
): boolean {
  const clearFingerBlock = (): void => {
    this._fingerSyntheticDrawingBlocked = false;
    if (this._fingerSyntheticDrawingClearTimer) {
      clearTimeout(this._fingerSyntheticDrawingClearTimer);
      this._fingerSyntheticDrawingClearTimer = 0;
    }
  };

  if (typeof PointerEvent !== 'undefined' && e instanceof PointerEvent) {
    if (e.pointerType === 'mouse') {
      clearFingerBlock();
    }
    return e.pointerType === 'pen' || e.pointerType === 'mouse';
  }
  if (typeof MouseEvent !== 'undefined' && e instanceof MouseEvent) {
    const caps = (
      e as MouseEvent & {
        sourceCapabilities?: { firesTouchEvents?: boolean };
      }
    ).sourceCapabilities;
    if (caps && caps.firesTouchEvents === false) {
      clearFingerBlock();
    }
    if (caps && caps.firesTouchEvents === true) {
      return false;
    }
  }
  if (this._fingerSyntheticDrawingBlocked) {
    return false;
  }
  const te = e as TouchEvent;
  if (te.touches && te.touches.length > 0) {
    const t = te.touches[0];
    // _onTouchStart 조기 반환 조건과 동일: 손가락은 필기 불가
    if (te.touches.length > 1 || t.touchType === 'direct' || t.radiusX > 0) {
      return false;
    }
    return true;
  }
  return true;
};

[
  '_onMouseDownInDrawingMode',
  '_onMouseMoveInDrawingMode',
  // '_onMouseUpInDrawingMode',
].forEach((name) => {
  (fabric.Canvas.prototype as any)['$' + name] = (
    fabric.Canvas.prototype as any
  )[name];
  (fabric.Canvas.prototype as any)[name] = function (e: Event): void {
    if (this._shouldAllowDrawingModeEvent(e)) {
      this['$' + name](e);
    }
  };
});

// (fabric.Canvas.prototype as any)._isMainEvent = (function (
//   originalFn: Function,
// ): Function {
//   return function (event: any): boolean {
//     // console.warn('is main event');

//     if (event instanceof TouchEvent) {
//       // console.warn(
//       //   event.type,
//       //   event.touches.length,
//       //   event.touches[0]?.touchType
//       // );

//       if (event.touches.length > 1) {
//         this.didStartMultiTouch = true;
//         return false;
//       }

//       if (event.type === 'touchend' && this.didStartFingerTouch) {
//         this.didStartFingerTouch = false;
//         return false;
//       }

//       if (event.type === 'touchend' && this.didStartMultiTouch) {
//         this.didStartMultiTouch = false;
//         return false;
//       }

//       if (event.touches.length > 0) {
//         this.touchRadiusX = event.touches[0].radiusX;
//         this.touchRadiusY = event.touches[0].radiusY;

//         if (this.touchRadiusX > 0 || this.touchRadiusY > 0) {
//           // console.warn('ignore fingertouch');
//           this.didStartFingerTouch = true;
//           return false;
//         } else {
//           // console.warn('not prevent scroll');
//           // event.preventDefault();
//         }
//       }
//     } else {
//       if (IS_TOUCH_DEVICE) {
//         return false;
//       }
//       // console.warn(event);
//       // console.warn('not a touch event');
//     }

//     return originalFn.call(this, event);
//   };
// })((fabric.Canvas.prototype as any)._isMainEvent);

Object.defineProperty(fabric.PencilBrush.prototype, 'drawStraightLine', {
  get() {
    return this.forceDrawStraightLine || this._drawStraightLine;
  },
  set(drawStraightLine: boolean) {
    this._drawStraightLine = drawStraightLine;
  },
});

/**
 * Canvas의 SVG 출력을 수정하여 모든 객체 정보를 순서대로 배열로 저장
 */
const originalCanvasToSVG = fabric.Canvas.prototype.toSVG;
fabric.Canvas.prototype.toSVG = function (reviver?: Function) {
  const svg = originalCanvasToSVG.call(this, reviver);

  // Canvas의 모든 객체를 순서대로 배열로 만들기
  const allObjectInfos: any[] = [];

  this.getObjects().forEach((obj: any) => {
    if (obj.type === 'i-text' || obj.type === 'textbox') {
      // 텍스트 객체: 줄바꿈이 포함된 원본 텍스트를 제대로 가져오기
      let originalTextContent = '';

      if (obj.type === 'i-text') {
        // IText의 경우 text 속성에 원본 내용이 저장됨
        originalTextContent = obj.text || '';
      } else if (obj.type === 'textbox') {
        // Textbox의 경우 text 속성에 원본 내용이 저장됨
        originalTextContent = obj.text || '';
      }

      const encodedText = btoa(encodeURIComponent(originalTextContent));

      const textInfo = {
        type: obj.type,
        editable: true,
        originalText: encodedText,
        originX: obj.originX || 'left',
        originY: obj.originY || 'top',
        fabricLeft: obj.left,
        fabricTop: obj.top,
        // Textbox인 경우 너비 정보 추가
        ...(obj.type === 'textbox' && { textboxWidth: obj.width }),
      };

      allObjectInfos.push(textInfo);
    } else {
      // 텍스트가 아닌 객체: null로 표시하여 인덱스 유지
      allObjectInfos.push(null);
    }
  });

  // 객체 정보가 있는 경우에만 SVG에 추가
  if (allObjectInfos.length > 0) {
    const encodedObjectInfos = btoa(JSON.stringify(allObjectInfos));

    // 최상위 svg 태그에 data-object-infos 속성 추가
    const withObjectInfosAttribute = svg.replace(
      /<svg /,
      `<svg data-object-infos="${encodedObjectInfos}" `
    );

    return withObjectInfosAttribute;
  }

  return svg;
};

/**
 * IText 객체의 SVG 출력 - 개별 속성 제거하고 기본 SVG만 반환
 */
const originalITextToSVG = fabric.IText.prototype.toSVG;
fabric.IText.prototype.toSVG = function (reviver?: Function) {
  // 기본 SVG 출력만 반환 (개별 속성 추가하지 않음)
  return originalITextToSVG.call(this, reviver);
};

/**
 * Textbox 객체의 SVG 출력 - 개별 속성 제거하고 기본 SVG만 반환
 */
const originalTextboxToSVG = fabric.Textbox.prototype.toSVG;
fabric.Textbox.prototype.toSVG = function (reviver?: Function) {
  // 기본 SVG 출력만 반환 (개별 속성 추가하지 않음)
  return originalTextboxToSVG.call(this, reviver);
};
